var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronBoldBackwardLtr = function SvgChevronBoldBackwardLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M63.769 86.75a4.217 4.217 0 0 0 5.988.004 4.28 4.28 0 0 0 .066-5.962l-.061-.063L39.22 49.954l30.477-30.681a4.28 4.28 0 0 0 .06-5.963l-.061-.063a4.216 4.216 0 0 0-5.927-.06l-.062.062L30.24 46.94a4.28 4.28 0 0 0-.063 5.96l.061.063z",
    clipRule: "evenodd"
  })));
};
export default SvgChevronBoldBackwardLtr;